import { render, staticRenderFns } from "./ItemCollection.vue?vue&type=template&id=0077fb2e&scoped=true&"
import script from "./ItemCollection.vue?vue&type=script&lang=js&"
export * from "./ItemCollection.vue?vue&type=script&lang=js&"
import style0 from "./ItemCollection.vue?vue&type=style&index=0&id=0077fb2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077fb2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
